import {
  ContactsType,
  ParentsType,
  TeamMembersType,
} from '../../../../pages/ifsp/ifspContextApi/IfspContex';
import {
  DateString,
  InsuranceType,
  IntakeCurrentHealthInfoType,
  IntakeFamilyInfoEcoMapType,
  IntakeFamilyInfoEicsType,
  IntakePregnancyInfoType,
  OptionType,
  ResourceRepoDTO,
} from '../../../../utils/type';
import { ApiMessage, ApiResponseHandler } from '../../../ApiResponseHandler';
import { REFERRAL_PROGRAM_KEY, THOM_BASE_URL } from '../../../Constant';
import ThomApiClient from '../../../ThomApiClient';
import { ConsentClientSignature } from '../Consent/ConsentServices';

export type IntakeClientInfoResponseType = {
  demographics: {
    clientId?: string;
    name: string;
    dphId: string;
    dateOfBirth: string;
    ageInMonths: string;
    sex: string;
    address: string;
  };
  insurance: InsuranceType[];
  guardians?: ContactsType[];
  presentForIntakeVisits: {
    teamMembers: TeamMembersType[];
    guardians: ParentsType[];
  };
  biologicalParents: string;
  eics: {
    childBorn: string;
    childAdopted: string;
    mothersResidenceInMACode: string | null;
    mothersCommunityCode: string | null;
  };
  dateOfIntakeVisit: DateString;
  descriptions: {
    childComeToFamilyDesc: string;
    childConcernDesc: string;
    familyConcernDesc: string;
    childPriorityDesc: string;
    familyPriorityDesc: string;
    earlyInterventionSupportDesc: string;
  };
  comment: string;
  isCurrentlyHeld?: boolean;
  heldBy?: string | null;
  isSigned?: boolean;
  reviewdBy?: string;
  reviewdDate?: string;
};

export type IntakePregnancyInfoResponseType = {
  prenatal: {
    prenatalCare: string;
    prenatalCareStart: string;
    prenatalCareRecievedAt: string;
    prenatalTests: string;
  };
  pregnancy: {
    pregnancyProblems: string;
    pregnancyProblemName: string[];
    pregnancyProblemOther: string;
    complicationWithPregnancy: string;
    neonatalCourse: string;
  };
  childBorn: {
    problemWhenChildBorn: string;
    problemWhenChildBornDeal: string;
    problemWhenChildBornNow: string;
    babyBornOnTime: string;
    babyBornEarlyOrLate: string;
  };
  drugUse: {
    alcoholUse: string;
    tobaccoUse: string;
    prescriptionDrugUse: string;
    recreationalDrugUse: string;
    medicationDuringTrimester: string;
    medicationsAnesthesia: string;
  };
  delivery: {
    labor: string;
    deliveryMethodNames: string[];
    caesareanExplain: string;
    considerationsAboutLaborOther: string;
    motherInHospital: string;
    dischargeDate: string | null;
  };
  tests: {
    treatmentName: string[];
    treatmentOther: string;
    newbornHearingScreening: string;
    specialNeedsMedicalEquipment: string;
    hearingEvaluation: string;
    hearingEvaluationDesc: string;
    visionScreening: string;
    visionScreeningDesc: string;
    hearingVisionConcerns: string;
  };
  specialCare: {
    specialCareAfterBirthAt: string[];
    hospitalNameNICU: string;
    hospitalPhoneNoNICU: string;
    howLongNICU: string;
    noOfDaysCCN: string;
    hospitalNameSC: string;
    hospitalPhoneNoSC: string;
    howLongSC: string;
    hospitalNameRN: string;
    hospitalPhoneNoRN: string;
    howLongRN: string;
    roomedInRN: string;
  };
  eics: {
    diagnosisOfSubstanceExposedNewborn: string;
    gestationalAge: string;
    birthWeight: string;
    weightInLbs: string;
    weightInOz: string;
    weightInGrams: string;
    multipleBirth: string;
    specialCareAfterBirth: string;
    childInNICU: string;
    daysInNICU: string;
  };
  comment: string;
  isCurrentlyHeld?: boolean;
  heldBy?: string | null;
  isSigned?: boolean;
  reviewdBy?: string;
  reviewdDate?: string;
};

export type IntakeCurrentHealthInfoResponseType = {
  medication: {
    medicalSpecialtyNames: string[];
    medicalSpecialtyOther: string;
    medicalProcedureNames: string[];
    medicalProcedureOther: string;
    medicationExplain: string;
    hospitals: HospitalsJSONType[];
  };
  healthIssue: {
    childOralHealthExplain: string;
    healthIssueNames: string[];
    seizureDisorderExplain: string;
    bloodLevel: string;
    bloodLevelDesc: string;
    heartDefectDesc: string;
    allergiesDesc: string;
    foodIntolerancesDesc: string;
    brokenBonesDesc: string;
    healthIssueOthers: string;
  };
  doctor: {
    immunizationsUpToDate: string;
    immunizationExplain: string;
    seenDentist: string;
    dentistFirstName: string;
    dentistlastName: string;
    dentistPhoneNumber: string;
    therapies: string;
    theraphyDesc: string;
    temperamentDesc: string;
  };
  childDesc: {
    childDesc: string;
    childEatingDesc: string;
    childFeedDesc: string;
    childGrowthDesc: string;
    childSleepDesc: string;
    activitiesDesc: string;
    childBehaviourDesc: string;
    socialRelationshipDesc: string;
    childSoundsDesc: string;
    childNeedsDesc: string;
    childFollowsDesc: string;
    childTolerateDesc: string;
    childlookSmileDesc: string;
    childUnderstandDesc: string;
  };
  childActivities: {
    childActivities: string;
    socialRelationship: string;
    childSmile: string;
    childRollOver: string;
    childCrawl: string;
    childWalkAlone: string;
    childSitIndependently: string;
    childImitateActions: string;
    childImitateSounds: string;
    childUseFirstWords: string;
    childMakeNoise: string;
    supportSystems: string;
  };
  eics: {
    hospitalization: string;
    childBloodLevel: string;
    childInsecureDifficulties: string;
    childNervousSystem: string;
    childMultipleTrauma: string;
    childHospitalized: string;
    childDiagnosedAtBirth: string;
    childChronicFeeding: string;
    smallSize: string;
  };
  comment: string;
  isCurrentlyHeld?: boolean;
  heldBy?: string | null;
  isSigned?: boolean;
  reviewdBy?: string;
  reviewdDate?: string;
};

export interface InatkeParentType {
  id: string;
  name: string;
  relationshipToClient: string;
  phoneNumber: string;
  address: string;
  email?: string;
}

export interface HospitalsJSONType {
  id: number;
  dateOfAdmitted: string | null;
  hospitalName: string;
  phoneNumber: string;
  comment: string;
}

export interface IntakeFamilyHistoryInfoResponseType {
  eics: IntakeFamilyInfoEicsType;
  ecoMap: IntakeFamilyInfoEcoMapType;
  fatherRace: string;
  fatherEthnicity: string;
  motherRace: string;
  motherEthnicity: string;
  lastSchoolGradeDesc: string;
  education: string;
  occupation: string;
  employeedBy: string;
  employerAddress: string;
  workPhone: string;
  parentsMaritalStatus: string;
  kinshipCare: string;
  extendedFamilyDesc: string;
  involvedRegularlyInChild: string;
  weakenedImmuneSystem: string;
  weakenedImmuneSystemDesc: string;
  familyMedicalHistoryDesc: string;
  comment: string;
  isCurrentlyHeld?: boolean;
  heldBy?: string | null;
  isSigned?: boolean;
  reviewdBy?: string;
  reviewdDate?: string;
}

export interface HeartBeatRequestType {
  clientId: string | null;
  tabName: string;
  userId: string | null;
}

export interface HeartBeatResponseType {
  clientId: string;
  userId: string;
  currentEmpName: string | null;
  currentEmpId: string | null;
  clientEmpId: string | null;
  clientEmpName: string | null;
  familyEmpId: string | null;
  familyEmpName: string | null;
  pregnancyEmpId: string | null;
  pregnancyEmpName: string | null;
  q1EmpId: string | null;
  q1EmpName: string | null;
  q2EmpId: string | null;
  q2EmpName: string | null;
  q3EmpId: string | null;
  q3EmpName: string | null;
  code: string | null;
  errorMessage: string | null;
  isSigned: boolean;
}

export interface IntakeReviewResponseType {
  demographics: DemographicResponseType;
  pregnancy: PreganancyEICSResponseType;
  currentHealth: CurrentHealthEICSResponseType;
  familyHistory: FamilyHistoryEICSResponseType;
  resourceDto: ResourceRepoDTO;
  signature: ConsentClientSignature[] | [];
  isSigned: boolean;
  reviewdBy: string;
  reviewdDate: string;
  canSign: boolean;
  revokeSignature: boolean;
}

export type DemographicResponseType = {
  race: string;
  ethnicity: string;
  multipleBirth: string;
  childBorn: string;
  childAdopted: string;
  primarySpokenLanguage: string;
  primarySpokenLanguageOther: string;
  primaryWrittenLanguage: string;
  primaryWrittenLanguageOther: string;
  mothersResidenceInMACode: string | null;
  mothersCommunityCode: OptionType | string | null;
};

export type PreganancyEICSResponseType = {
  diagnosisOfSubstanceExposedNewborn: string;
  gestationalAge: string;
  gestationalAgeCheck?: boolean;
  childDiagnosedAtBirth: string;
  siblingWithSEN: string;
  birthMotherParity: string;
  birthWeight: string;
  weightInLbs: string;
  weightInOz: string;
  weightInGrams: string;
  childInNICU: string;
  daysInNICU: string;
  daysInNICUCheck?: boolean;
};

export type CurrentHealthEICSResponseType = {
  childHospitalized: string;
  childBloodLevel: string;
  childInsecureDifficulties: string;
  childNervousSystem: string;
  childMultipleTrauma: string;
  childChronicFeeding: string;
  smallSize: string;
};

export type FamilyHistoryEICSResponseType = {
  parentalChronicIllness: string;
  affectingChild: string;
  mothersEducationYear: string;
  mothersEducationYearCheck?: boolean;
  lackingAdequate: string;
  povertyLevel: string;
  protectiveServiceInvestigation: string;
  homelessness: string;
  homelessnessInPast: string;
  abuseAffectingChild: string;
  socialSupport: string;
};
export const heartBeat = async (hearBeatRequest: HeartBeatRequestType) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().post<
      HeartBeatRequestType,
      HeartBeatResponseType
    >(`heartbeat`, hearBeatRequest),
  );
};

export const getIntakeDetailsByTab = async (clientId: string) => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);

  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<IntakeClientInfoResponseType>(
      `intake/clientInfo?clientId=${clientId}&referralProgramId=${
        referralProgramId ?? ''
      }`,
    ),
  );
};

export const getIntakePregnancyInfo = async (clientId: string) => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);

  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<IntakePregnancyInfoType>(
      `intake/pregnancy?clientId=${clientId}&referralProgramId=${
        referralProgramId ?? ''
      }`,
    ),
  );
};

export const getIntakeCurrentHealthInfoDetails = async (clientId: string) => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);

  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<IntakeCurrentHealthInfoType>(
      `intake/currentHealth?clientId=${clientId}&referralProgramId=${
        referralProgramId ?? ''
      }`,
    ),
  );
};

export const getIntakeFamilyHistoryInfoDetails = async (clientId: string) => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);

  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<IntakeFamilyHistoryInfoResponseType>(
      `intake/family?clientId=${clientId}&referralProgramId=${
        referralProgramId ?? ''
      }`,
    ),
  );
};

export const getIntakeReviewDetails = async (clientId: string) => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);

  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<IntakeReviewResponseType>(
      `intake/review?clientId=${clientId}&referralProgramId=${
        referralProgramId ?? ''
      }`,
    ),
  );
};

export const putIntakeClientInfo = async (
  clientId: string,
  params: IntakeClientInfoResponseType,
): Promise<ApiMessage> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);

  return ApiResponseHandler(
    await ThomApiClient.getInstance().put<
      IntakeClientInfoResponseType,
      ApiMessage
    >(
      `intake/clientInfo?clientId=${clientId}&referralProgramId=${
        referralProgramId ?? ''
      }`,
      params,
    ),
  );
};

export const putIntakePregnancyInfo = async (
  clientId: string,
  params: IntakePregnancyInfoType,
): Promise<ApiMessage> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);

  return ApiResponseHandler(
    await ThomApiClient.getInstance().put<IntakePregnancyInfoType, ApiMessage>(
      `intake/pregnancy?clientId=${clientId}&referralProgramId=${
        referralProgramId ?? ''
      }`,
      params,
    ),
  );
};

export const putIntakeCurrentHealthInfo = async (
  clientId: string,
  params: IntakeCurrentHealthInfoType,
): Promise<ApiMessage> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);

  return ApiResponseHandler(
    await ThomApiClient.getInstance().put<
      IntakeCurrentHealthInfoType,
      ApiMessage
    >(
      `intake/currentHealth?clientId=${clientId}&referralProgramId=${
        referralProgramId ?? ''
      }`,
      params,
    ),
  );
};

export const putIntakeFamilyHistoryInfo = async (
  clientId: string,
  params: IntakeFamilyHistoryInfoResponseType,
): Promise<ApiMessage> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);

  return ApiResponseHandler(
    await ThomApiClient.getInstance().put<
      IntakeFamilyHistoryInfoResponseType,
      ApiMessage
    >(
      `intake/family?clientId=${clientId}&referralProgramId=${
        referralProgramId ?? ''
      }`,
      params,
    ),
  );
};

export const putIntakeReviewDetails = async (
  clientId: string,
  params: IntakeReviewResponseType,
): Promise<ApiMessage> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);

  return ApiResponseHandler(
    await ThomApiClient.getInstance().put<IntakeReviewResponseType, ApiMessage>(
      `intake/review?clientId=${clientId}&referralProgramId=${
        referralProgramId ?? ''
      }`,
      params,
    ),
  );
};

export const downloadIntakeData = async (
  clientId: string,
  localTimezone: string,
): Promise<Blob> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);

  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<Blob>(
      `intake/download?clientId=${clientId}&timezone=${localTimezone}&referralProgramId=${
        referralProgramId ?? ''
      }`,
      {},
      {
        baseURL: THOM_BASE_URL,
        responseType: 'blob',
      },
    ),
  );
};
